app.service('simpleToastr', function ($global, console) {
	const timeout = 5000;

	function success({header, message}) {
		const content = (header && header.length ? `<h2>${header}</h2>` : '') + (message && message.length ? `<p>${message}</p>` : '');
		generate(content)
	}

	function error({header, message}) {
		const content = (header && header.length ? `<h2>${header}</h2>` : '') + (message && message.length ? `<p>${message}</p>` : '');
		generate(content, { modifier: 'modifier-error' })
	}

	function open(id, timer) {
		if (isExist(id)) {
			console.log('otwieramy warstwę: ' + id);
			let $simpleToastr = $('[data-simple-toastr-id=' + id + ']');
			$simpleToastr.addClass('toastr-is-open');
			setAutoClose(id, timer);
			return $simpleToastr;
		} else {
			console.log('NIE ISTNIEJE SIMPLE TOASTR: ' + id);
		}
	}
	function isOpen(id) {
		if (isExist(id)) {
			return $('[data-simple-toastr-id=' + id + ']').hasClass('toastr-is-open');
		}
		return false;
	}
	function isExist(id) {
		return $('[data-simple-toastr-id=' + id + ']').length ? true : false;
	}
	function setAutoClose(id, timer) {
		setTimeout(function () {
			if (isOpen(id)) {
				close(id);
			}
		}, (timer && timer > 1) ? timer * 1000 : 5000);
	}
	function close(id) {
		let $toastr = $('[data-simple-toastr-id=' + id + ']');
		$toastr.addClass('toastr-is-closing');
		setTimeout(function () {
			if (isOpen(id)) {
				$toastr.removeClass('toastr-is-open toastr-is-closing');
			}
		}, 600);
	}

	function setEvents() {
		$('body').on('click', '.js-simple-toastr-close', function () {
			close($(this).parent().data('simple-toastr-id'));
		});
	}
	function init() {
		setEvents();
	}
	function generate(content, params) {

		function close() {
			$box.addClass('toastr-is-closing');
			setTimeout(function () {
				$box.remove();
			}, 600);
		}

		let $box = $(`<div class="simple-toastr toastr-is-open">${content}</div>`).appendTo('body');

		if (params && params.modifier) {
			$box.addClass(params.modifier);
		}

		$(`<div class="toastr-close">
			<svg width="32" height="32" viewBox="0 0 32 32" fill="none" class="close-progress">
				<path d="M11 21L21 11M11 11L21 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
				<circle cx="16" cy="16" r="14" />
			</svg>
		</div>`).appendTo($box).click(close);

		setTimeout(close, timeout);
	}

	$global('openSimpleToastr', open);
	$global('generateSimpleToastr', generate);
	return {
		init,
		generate,
		open,
		isOpen,
		success,
		error
	};
});
